// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Nachtrag, NachtragDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateBaustelleNachtrag(): (
  baustellenId: string,
  nachtragId: string,
  requestBody: NachtragDaten
) => Promise<Nachtrag> {
  const getAPI = useGetApi();
  return useCallback(
    async (baustellenId, nachtragId, requestBody) =>
      (await getAPI()).baustellen.updateBaustelleNachtrag({
        baustellenId,
        nachtragId,
        requestBody,
      }),
    [getAPI]
  );
}
